import { render, staticRenderFns } from "./Erc1155TransationList.vue?vue&type=template&id=cf392a1a&"
import script from "./Erc1155TransationList.vue?vue&type=script&lang=js&"
export * from "./Erc1155TransationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports